import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Container, PageHeader, Spinner } from "@/components/shared";
import { toast } from "sonner";
import { Newspaper, Calendar, ExternalLink } from "lucide-react";

const CAT_COLORS = {
  "Racisme": "text-red-300 border-red-500/30 bg-red-500/[0.08]",
  "Discriminations": "text-gold border-gold/30 bg-gold/[0.08]",
  "Libertés publiques": "text-blue-300 border-blue-500/30 bg-blue-500/[0.08]",
  "Droits des citoyens": "text-emerald-300 border-emerald-500/30 bg-emerald-500/[0.08]",
};

export default function News() {
  const [news, setNews] = useState(null);

  useEffect(() => {
    api.get("/news").then(({ data }) => setNews(data.news || [])).catch((e) => toast.error(apiErr(e)));
  }, []);

  return (
    <Container>
      <PageHeader eyebrow="À jour" title="Actualités juridiques"
        subtitle="Les évolutions importantes du droit français : racisme, discriminations, libertés publiques et droits des citoyens." />

      {!news && <Spinner label="Chargement des actualités..." />}
      {news && news.length === 0 && (
        <div className="card-surface p-8 text-center">
          <Newspaper size={28} className="text-white/30 mx-auto mb-2" />
          <p className="text-white/50 text-sm">Aucune actualité pour le moment. Revenez bientôt.</p>
        </div>
      )}
      <div className="space-y-4">
        {news?.map((n) => (
          <article key={n.news_id} data-testid={`news-${n.news_id}`} className="card-surface p-5 fade-up">
            <div className="flex items-center gap-3 mb-2 flex-wrap">
              <span className={`text-[11px] px-2.5 py-1 rounded-full border ${CAT_COLORS[n.category] || "text-white/60 border-white/15 bg-white/[0.04]"}`}>{n.category}</span>
              <span className="text-white/35 text-xs flex items-center gap-1">
                <Calendar size={12} /> {new Date(n.created_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
              </span>
            </div>
            <h3 className="font-display text-lg mb-1">{n.title}</h3>
            {n.summary && <p className="text-white/60 text-sm mb-2">{n.summary}</p>}
            <p className="text-white/75 text-sm leading-relaxed whitespace-pre-wrap">{n.body}</p>
            {n.source && (
              <p className="text-white/35 text-xs mt-3 flex items-center gap-1"><ExternalLink size={12} /> Source : {n.source}</p>
            )}
          </article>
        ))}
      </div>
    </Container>
  );
}
